import React, { Component } from "react";
import * as Constants from "../../consts/Constants.js";
import EmergencyMarker from "./Marker.js";
import ListAlerts from "./ListAlerts.js";
import InfoBox from "./InfoBox.js";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import Axios from "axios";
import { emergencyErrors } from "../../consts/ErrorMessages.js";
import { Howl } from "howler";
import Alert from "../../components/common/Alert";
import "../../../src/styles/css/Leaflet.css";

const TIMER = 15000;
const ESTADO_PENDIENTE_RECEPCION = 0;
const ESTADO_CERRADO = 3;

const alarma = new Howl({
  src: ["./Alarma.mp3"],
  loop: true,
});

function ChangeMapView({ coords }) {
  const map = useMap();
  map.setView(coords, map.getZoom());

  return null;
}

class Emergency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alerts: [],
      selected: null,
      errors: [],
      open: true,
      centerMap: [Constants.LATITUD_AYACUCHO, Constants.LONGITUD_AYACUCHO],
    };
    this.playing = false;
    this.setOpen = this.setOpen.bind(this);
  }

  setOpen(valor) {
    this.setState({ ...this.state, open: valor });
  }

  setCenterMap(latitude, longitude) {
    console.log(latitude, longitude);
    //const map = useMap();
    //map.setView([latitude, longitude], map.getZoom());
    this.setState({ ...this.state, centerMap: [latitude, longitude] });
  }

  onMapCreated(map) {
    map.setOptions({
      disableDefaultUI: true,
    });
  }

  componentDidMount() {
    this.loadData();
    this.timer = setInterval(() => this.loadData(), TIMER);
  }

  alarmPlay(alerts) {
    let condition = (alert) => alert.state === ESTADO_PENDIENTE_RECEPCION;
    if (alerts.some(condition)) {
      if (!this.playing) {
        alarma.play();
        this.playing = true;
      }
    } else {
      alarma.pause();
      this.playing = false;
    }
  }

  loadData() {
    Axios.get(Constants.FINAL_URL_EMERGENCY + "/current-alerts")
      .then((response) => {
        let newSelected = null;
        if (this.state.selected !== null) {
          response.data.forEach((item, i) => {
            if (item.id === this.state.selected.id) {
              newSelected = item;
            }
          });
        }
        this.alarmPlay(response.data);
        this.setState({
          alerts: response.data,
          selected: newSelected,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  clickOnMarker(alert) {
    this.setState({ alerts: this.state.alerts, selected: alert });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  updateState(alert) {
    let auth = JSON.parse(localStorage.getItem("auth"));

    let reply = {
      requestId: alert.id,
      serviceId: Constants.SERVICE_EMERGENCY_ID,
      userId: auth.userId,
      code: alert.state + 1,
    };

    Axios.post(
      Constants.FINAL_URL_EMERGENCY + "/requests/" + alert.id + "/replies",
      reply
    )
      .then((response) => {
        if (response.status === Constants.RESPONSE_OK) {
          let newAlerts = [];
          this.state.alerts.map((element) => {
            if (element.id === reply.requestId) {
              element.state = reply.code;
            }
            if (element.state !== ESTADO_CERRADO) {
              newAlerts.push(element);
            } else if (
              this.state.selected !== null &&
              this.state.selected.id === element.id
            ) {
              this.setState({ ...this.state, selected: null });
            }
          });
          this.setState({ ...this.state, alerts: newAlerts });
          this.setOpen(false);
          this.alarmPlay(newAlerts);
        } else {
          let errors = [];
          errors.push(emergencyErrors.server);
          this.setOpen(true);
          this.setState({ ...this.state, errors: errors });
        }
      })
      .catch((error) => {
        let errors = [];
        errors.push(emergencyErrors.server);
        this.setOpen(true);
        this.setState({ ...this.state, errors: errors });
      });
  }

  render() {
    return (
      <div>
        <Alert
          errors={this.state.errors}
          severity="error"
          open={this.state.open}
          setOpen={this.setOpen}
        />
        <div
          style={{
            display: "flex",
            height: "80%",
            width: "90%",
            position: "absolute",
          }}
        >
          <div style={{ height: "100%", width: "80%", overflow: "hidden" }}>
            <MapContainer
              style={{
                height: "100%",
                width: "100%",
                overflow: "hidden",
                zIndex: 399,
              }}
              center={this.state.centerMap}
              zoom={13}
              scrollWheelZoom={true}
            >
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {this.state.alerts.map((alert, index) =>
                alert.location !== undefined ? (
                  <EmergencyMarker
                    alert={alert}
                    key={alert.userId}
                    lat={alert.location.latitude}
                    lng={alert.location.longitude}
                    state={alert.state}
                    clickcall={this.clickOnMarker.bind(this)}
                  />
                ) : null
              )}
              <ChangeMapView coords={this.state.centerMap} />
            </MapContainer>

            {this.state.selected !== null ? (
              <InfoBox alert={this.state.selected} />
            ) : null}
          </div>
          <ListAlerts
            updateState={this.updateState.bind(this)}
            alerts={this.state.alerts}
            updateCenter={this.setCenterMap.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default Emergency;
